
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M228.5 44.5C174.9 51.6 126.6 78.4 90.8 121c-14.7 17.5-29.5 44.7-37.2 68.1C46.1 212 43 231.3 43 256s3.1 44 10.6 66.9C68.7 369 99.3 408.3 141.5 436c17.8 11.6 45.4 23.1 67.5 28 21.1 4.7 49.5 6.3 70.5 4 38.2-4.3 75.1-19.1 106.5-42.8 18.1-13.7 40.3-38.7 53-59.6 27.4-45.5 36.7-101.9 25.4-154.6-6.6-30.8-19.8-59.1-39.7-85.5-7.3-9.6-26.5-29-36.3-36.7-31.1-24.5-70-40.5-108.6-44.7-12.8-1.4-38.8-1.2-51.3.4M285.6 88c60.5 10.3 112.3 54.8 131.9 113.2 24.7 73.8-2.5 153.5-67 196.7-78.2 52.3-184 31-236.6-47.7-37.9-56.6-37.9-131.9 0-188.4 13.5-20.1 28.1-34.7 48.1-48 36.4-24.1 79.8-33.2 123.6-25.8"}}),_c('path',{attrs:{"d":"M246.5 150.1c-12.8 1.9-25.5 8.3-34.8 17.3-7.4 7.3-9.1 11.2-8.5 19.7.8 11 9.3 18.9 20.5 18.9 6.8 0 11-1.8 16.6-6.9 5.3-4.9 10.2-7.1 15.9-7.1 8.5.1 17.1 6.4 19.8 14.5 1.9 5.9.8 13.9-2.6 18.8-3 4.2-6.1 6.2-18.2 11.3-7.8 3.3-16.2 11.9-18.6 19-2.2 6.4-2.2 25-.1 30.2 3.3 7.8 10.6 12.6 19.5 12.6 10.9.1 19.9-8.1 20.8-18.8l.4-5.5 7.7-3.8c11.1-5.5 22.4-16.9 28-28.3 6.9-14.1 8.6-26.8 5.5-41.8-3.8-18.7-16.4-35.1-33.6-43.8-11.7-5.9-25.9-8.2-38.3-6.3m1.5 171.5c-10.7 4.6-15.9 17.4-11.5 28.2 5.4 12.8 22.1 16.9 32.9 8 12-9.9 10.1-28.4-3.7-35.3-5.9-2.9-12.3-3.2-17.7-.9"}})])
          )
        }
      }
    